import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    ChooseCarrierStep: {
        defaultMessage: 'Step 1: Choose carrier',
        id: 'Components.InsurancePicker.Header.Step1',
    },

    ChooseBcbsStep: {
        defaultMessage: 'Step 2: Choose BCBS',
        id: 'Components.InsurancePicker.Header.BcbsStep',
    },

    ChoosePlanStep: {
        defaultMessage: 'Step {stepNumber}: Choose plan',
        id: 'Components.InsurancePicker.Header.PlanStep',
    },

    ChooseCarrier: {
        defaultMessage: '1. Choose carrier',
        id: 'Components.InsurancePicker.Header.ChooseCarrier',
    },

    ChooseBcbs: {
        defaultMessage: '2. Choose BCBS',
        id: 'Components.InsurancePicker.Header.ChooseBcbs',
    },

    ChoosePlan: {
        defaultMessage: '{stepNumber}. Choose plan',
        id: 'Components.InsurancePicker.Header.ChoosePlan',
    },
});
